import React, { useRef, useState } from 'react';
import './FileUpload.scss';
import languageManager from '../../helpers/Language';
import { NoOp } from '../../helpers/Utils';
import FileIcon from './FileIcon';
import { CloseButton, Card } from 'react-bootstrap';
import { UploadFileStatus } from '../../helpers/FileUploadManager';
import { ProgressBar } from 'react-bootstrap';
import { getFileExtension } from '../../helpers/File';
import UserAnalytic from '../../helpers/UserAnalytic';

export const getFiles = (ev) => {
    const files = [];
    for (var i = 0; i < ev.dataTransfer.files.length; i++) {
        const item = ev.dataTransfer.files[i];
        const fileExtension = getFileExtension(item.name);
        if (!fileExtension) continue;
        files.push(item);
    }
    return files;
}

export const FileUploadBox = ({
    onAddFile = NoOp,
    uploadMaxStr
}) => {
    const [isDragOver, setDragOverStatus] = useState(false);
    const inputFileRef = useRef(null);
    const handleBrowseFile = (inputFileRef) => {
        if (!inputFileRef.current) return;
        inputFileRef.current.click();
    };
    const handleFileList = (e) => {
        const fileList = e.target.files;
        UserAnalytic.event({
            category: 'drive_upload',
            action: 'Upload files',
        });
        onAddFile(fileList);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        UserAnalytic.event({
            category: 'drive_upload',
            action: 'Drop File Over',
        });
        setDragOverStatus(false);
        const fileList = getFiles(e);
        onAddFile(fileList);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
        setDragOverStatus(true);
    };
    const handleDragLeave = (e) => {
        e.preventDefault();
        setDragOverStatus(false);
    };
    return (
        <div
            onClick={() => handleBrowseFile(inputFileRef)}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragEnter={handleDragOver}

            onDragLeave={handleDragLeave}
            onDragEnd={handleDragLeave}
            className={'fu-upload-box text-center shadow-sm ' + (isDragOver ? 'zone-active' : '')}>
            <span>
                {languageManager.T('LABEL_DRAG_N_DROP_FILES')}<br />
                <i>{languageManager.T('SETTINGS_LABEL_FILE_SIZE_LIMIT')}: {uploadMaxStr}</i>
            </span>
            <input
                type="file"
                style={{ display: 'none' }}
                multiple
                ref={inputFileRef}
                onChange={handleFileList}
            />
        </div>
    );
};

export const UploadFileElement = ({
    file,
    onRemove = NoOp
}) => {
    let body = null;
    let borderUploadStatusMap = {
        [UploadFileStatus.DONE]: 'border-success',
        [UploadFileStatus.ERROR]: 'border-danger'
    };

    switch (file.getUploadStatus()) {
    // switch (UploadFileStatus.UPLOADING) {
        case UploadFileStatus.INIT:
            body = (
                <>
                    <div className="flex-grow-1">
                        <b>{file.getName()}</b> <span className="text-muted">- {file.getSizeFormat()}</span>
                        <div>
                            <span className="text-muted">{languageManager.T('SETTINGS_LABEL_UPLOAD_WILL_BE_UPLOADED')}</span> <b>{languageManager.T(file.getInboxFolderCode())}</b>
                        </div>
                    </div>
                    <div>
                        <CloseButton
                            title="Remove from the list"
                            onClick={() => onRemove(file.id)}
                        />
                    </div>
                </>
            );
            break;
        case UploadFileStatus.UPLOADING:
            const now = file.getProgressPercentage();
            body = (
                <>
                    <div className="flex-grow-1">
                        <b>{file.getName()}</b> <span className="text-muted">- {file.getSizeFormat()}</span>
                        <div>
                            {/* <span className="text-muted">Uploading</span> <b>{languageManager.T(file.getInboxFolderCode())}</b> */}
                            <ProgressBar
                                className="mt-3"
                                now={now}
                                label={`${now}%`}
                                animated
                            />
                        </div>
                    </div>
                </>
            );
            break;
        case UploadFileStatus.DONE:
            body = (
                <>
                    <div className="flex-grow-1">
                        <b>{file.getName()}</b> <span className="text-muted">- {file.getSizeFormat()}</span>
                        <div>
                            {languageManager.T('SETTINGS_LABEL_FILE_UPLOADED')}
                        </div>
                    </div>
                </>
            );
            break;
        case UploadFileStatus.ERROR:
            body = (
                <>
                    <div className="flex-grow-1">
                        <b>{file.getName()}</b> <span className="text-muted">- {file.getSizeFormat()}</span>
                        <div>
                            {languageManager.T('SETTINGS_LABEL_FILE_UPLOAD_FAILED')} - <i>{file.getFormatedError()}</i>
                        </div>
                    </div>
                    <div>
                        <CloseButton
                            title="Remove from the list"
                            onClick={() => onRemove(file.id)}
                        />
                    </div>
                </>
            );
            break;
        default:
            body = (
                <>
                    <div className="flex-grow-1">
                        <b>{file.getName()}</b> <span className="text-muted">- {file.getSizeFormat()}</span>
                        <div>
                            <span className="text-muted">{languageManager.T('SETTINGS_LABEL_UPLOAD_WILL_BE_UPLOADED')}</span> <b>{languageManager.T(file.getInboxFolderCode())}</b>
                        </div>
                    </div>
                </>
            );
            break;
    }
    return (
        <Card className={`mt-2 ${borderUploadStatusMap[file.getUploadStatus()] ?? ''}`}>
            <Card.Body className="p-0">
                <div className="d-flex p-2">
                    <FileIcon fileType={file.getGuessedType()} />
                    {body}
                </div>
            </Card.Body>
        </Card>
    );
};

export const FileUploadList = ({
    uploadManager: { uManager },
    onRemoveFile = NoOp
}) => {
    // const files = (uploadManager.getFiles ? uploadManager.getFiles() : []);
    const files = uManager.getFiles();
    const fileItems = files.map((file) => (
        <UploadFileElement
            key={file.id}
            file={file}
            onRemove={onRemoveFile}
        />
    ));

    return (
        <>
            {
            fileItems.length ?
                fileItems :
                (
                    <Card className="mt-2">
                        <Card.Body className="p-0">
                            <span className="d-block text-muted text-center p-3">{languageManager.T('SETTINGS_LABEL_UPLOAD_LIST_EMPTY')}</span>
                        </Card.Body>
                    </Card>
                )
            }
        </>
    );
};

const FileUpload = () => (null);

FileUpload.UploadBox = FileUploadBox;
FileUpload.UploadList = FileUploadList;

export default FileUpload;
